import { call, fork, put, takeEvery } from 'redux-saga/effects';

import {
  caseActionSubmitFail,
  caseActionSubmitSuccess,
  CASE_ACTION_SUBMIT
} from '../../redux/actions/cm/caseAction';

import {
  caseActionSubmit,
  deleteSTRReportByCaseId
} from '../../services/cm/cases';
import { fetchHistoryForCase } from '../../services/cm/historyItems';

function* caseActionSubmitWorker({ caseActionDetails }) {
  try {
    console.log('[caseActionSubmitWorker] submitting caseAction:', caseActionDetails);
    yield call(caseActionSubmit, { caseActionDetails });

    if (caseActionDetails?.status === 'RE_OPENED') {
      console.log('[caseActionSubmitWorker] status=RE_OPENED, calling deleteSTRReportByCaseId for caseId:', caseActionDetails.caseId);
      try {
        yield call(deleteSTRReportByCaseId, caseActionDetails.caseId);
        console.log('[caseActionSubmitWorker] deleteSTRReportByCaseId succeeded');
      } catch (deleteErr) {
        console.warn('[caseActionSubmitWorker] deleteSTRReportByCaseId failed (non-blocking):', deleteErr?.message);
      }
    } else {
      console.log('[caseActionSubmitWorker] status:', caseActionDetails?.status, '— skip delete');
    }

    yield put(caseActionSubmitSuccess());
  } catch (error) {
    const responseData = error?.response?.data;
    const errorMessage =
      responseData?.code === 'AUTH_ATTRIBUTEERROR' ? responseData.msg : null;
    yield put(caseActionSubmitFail(errorMessage));
  }
}

export function* watchCaseActionSubmit() {
  yield takeEvery(
    CASE_ACTION_SUBMIT,
    function* ({ payload: { caseActionDetails } }) {
      yield fork(caseActionSubmitWorker, { caseActionDetails });
    }
  );
}
